import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

/**
 * Slice F4 — Lista de espera. Mantiene el listado del restaurante en memoria
 * con filtro opcional por fecha. Las mutaciones (crear / notificar / cancelar)
 * vienen desde la vista admin; el endpoint público de "apuntarse" lo llama
 * el wizard de reservas online (PublicBookingService) que NO usa este slice
 * (esa vista es standalone sin Redux).
 */
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  entries: [],
  // Filtro fecha activo (YYYY-MM-DD). null = todas.
  dateFilter: null,
};

const slice = createSlice({
  name: "waitlist",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setEntries(state, action) {
      state.isLoading = false;
      state.isLoaded = true;
      state.entries = action.payload || [];
    },
    setDateFilter(state, action) {
      state.dateFilter = action.payload || null;
    },
    upsertEntry(state, action) {
      const e = action.payload;
      if (!e) return;
      const idx = state.entries.findIndex((x) => x.id === e.id);
      if (idx >= 0) state.entries[idx] = { ...state.entries[idx], ...e };
      else state.entries.unshift(e);
    },
    removeEntry(state, action) {
      const id = action.payload;
      state.entries = state.entries.filter((x) => x.id !== id);
    },
  },
});

export default slice.reducer;
export const { setDateFilter } = slice.actions;

export function fetchWaitlist({ date } = {}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const params = date ? { date } : {};
      const res = await axios.get("/Waitlist/Get", { params });
      dispatch(slice.actions.setEntries(Array.isArray(res.data) ? res.data : []));
    } catch (e) {
      dispatch(slice.actions.hasError(e?.message || "Error cargando waitlist"));
    }
  };
}

export function createWaitlistEntry(dto) {
  return async (dispatch) => {
    try {
      const res = await axios.post("/Waitlist/Create", dto);
      dispatch(slice.actions.upsertEntry(res.data));
      return res.data;
    } catch (e) {
      dispatch(slice.actions.hasError(e?.message || "Error creando entrada"));
      throw e;
    }
  };
}

export function notifyWaitlistEntry(id, dto = {}) {
  return async (dispatch) => {
    try {
      const res = await axios.post(`/Waitlist/Notify/${id}`, dto);
      dispatch(slice.actions.upsertEntry(res.data));
      return res.data;
    } catch (e) {
      dispatch(slice.actions.hasError(e?.message || "Error notificando"));
      throw e;
    }
  };
}

export function cancelWaitlistEntry(id) {
  return async (dispatch) => {
    try {
      await axios.post(`/Waitlist/Cancel/${id}`);
      dispatch(slice.actions.removeEntry(id));
    } catch (e) {
      dispatch(slice.actions.hasError(e?.message || "Error cancelando"));
      throw e;
    }
  };
}
